import React from 'react';
import classNames from 'classnames';
import RcCollapse from '../rc-components/collapse';
const CollapsePanel = (props) => {
    const { prefixCls, className = '', showArrow = true } = props;
    const collapsePanelClassName = classNames({
        [`${prefixCls}-no-arrow`]: !showArrow,
    }, className);
    return React.createElement(RcCollapse.Panel, Object.assign({}, props, { className: collapsePanelClassName }));
};
export default CollapsePanel;
